import React from 'react';
import "./Description2.css"
import dear from "./dear.png"
import hrx from "./hr.png";
import icon1 from "./icon1.png"
import icon2 from "./icon2.png"
import icon3 from "./icon3.png"
function Description2() {
  return <div className={"description"}>

    <img src={dear} className={"img_top img-center"} alt={"Dear"} />
    <div ><img className={"img_top img-center second"} src={hrx} /></div>
    <div className={"dear"}>DEAR</div>
    <div className={"subtitle"}>Η πλατφόρμα DEAR προσφέρει πληροφορίες σχετικά με την Οδική Ασφάλεια στην Ελλάδα και συγκεκριμένα:</div>
    <div className={"table-tag"}>
      <div className={"subtable"}>
        <div className={"subtable-step"}>
          <img src={icon1} alt={"icon1"} />
          <div className={"table-header"}>Βήμα 1ο</div>
        </div>
        <div className={"table-subtitle"}>
          Συλλέγει Δεδομένα
        </div>
        <div className={"table-content"}>Συλλέγει δευτερογενή δεδομένα σχετικά με τα τροχαία ατυχήματα από έγκυρες πηγές σε εγχώριο και πανευρωπαϊκό επίπεδο (π.χ. ΕΛΣΤΑΤ, Eurostat).
        </div>
      </div>
      <div className={"subtable"}>
        <div className={"subtable-step"}>
          <img src={icon2} alt={"icon2"} />
          <div className={"table-header"}>Βήμα 2ο</div>
        </div>
        <div className={"table-subtitle"}>
        Δημιουργεί Δείκτες Οδικής Ασφάλειας
        </div>
        <div className={"table-content"}>
          Αναλύει τα δευτερογενή δεδομένα για τη δημιουργία των δεικτών οδικής ασφάλειας
        </div>
      </div>
      <div className={"subtable"}>
        <div className={"subtable-step"}>
          <img src={icon3} alt={"icon3"} height={"48"} width={"48"} />
          <div className={"table-header"}>Βήμα 3ο</div>
        </div>
        <div className={"table-subtitle"}>
          Οπτικοποιεί Δείκτες & Δεδομένα
        </div>

        <div className={"table-content"}>
          Οπτικοποιεί τα δεδομένα και τους δείκτες  οδικής ασφάλειας μέσω γραφημάτων, πινάκων και χαρτών.
        </div>
      </div>

    </div>
  </div>


}

export default Description2;